<template>
  <div>
    <!-- 传灯祈福法会 -->
    <ChuanDengQiFuRecord ref="currentCom" :page-data="payload" :pay="pay" v-if="$getSpecialReligiousAssemblyRecord([238]).includes(payload.id)" />
    <!-- 皈依法会 -->
    <GuiYiRecord ref="currentCom" :page-data="payload" :pay="pay" v-else-if="$getSpecialReligiousAssemblyRecord([230, 243]).includes(payload.id)" />
  </div>
</template>

<script>
  import ChuanDengQiFuRecord from './components/ChuanDengQiFuRecord'
  import GuiYiRecord from './components/GuiYiRecord'
  import { WxPay } from '@/utils/Pay'
  export default {
    data () {
      return {
        payload: {
          price: 0,
          goodsNum: 1
        }
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      // 支付
      pay (form) {
        // 微信支付，因为该商户为子商户，没有回调功能，支付成功就完事了。。。
        new WxPay(form, data => {
          if (data.orderStatus) {
            this.$router.push('/pay/success')
          }
        })
      },
      // 详情
      getData () {
        this.$faWuApi.faHui.getItemData({
          id: this.$route.query.pId
        }).then(res => {
          if (res.success) {
            this.payload = res.data
          }
        })
      }
    },
    components: {
      ChuanDengQiFuRecord,
      GuiYiRecord
    }
  }
</script>